import { SerializedDGSPoolConfig } from 'state/deblox/types'
import { serializeTokens } from '../tokens'
import { PoolCategory } from '../types'

const serializedTokens = serializeTokens()

const pools: SerializedDGSPoolConfig[] = [
  {
    sousId: 0,
    stakingToken: serializedTokens.dgs,
    earningToken: serializedTokens.dgsg,
    contractAddress: {
      97: '0xC6fe4530b403f2397F8a6E7D6aCed8D54912f481',
      56: '0x497184a43a45940f3B42f1949BaB46eE35991eD7',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '1',
    sortOrder: 0,
    isFinished: false,
    isLPPool: false
  },
  {
    sousId: 1,
    stakingToken: serializedTokens.dgs,
    earningToken: serializedTokens.dgsg,
    contractAddress: {
      97: '0xC6fe4530b403f2397F8a6E7D6aCed8D54912f481',
      56: '0x27C762241f17a1C5253A0Db2e35550F9d7232091',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '1',
    sortOrder: 1,
    isFinished: false,
    isLPPool: false
  }
]

export default pools
